module.exports = __webpack_public_path__ + "static/media/the-extra-publisher-logo-60px-high.c6354ca6.png";